import { type SheetOffsets, SheetOffsetsWasm } from '@/app/quadratic-core/quadratic_core';

export function tryLoadSheetOffsets(offsets: string, context: string): SheetOffsets | undefined {
  try {
    return SheetOffsetsWasm.load(offsets);
  } catch (error) {
    console.warn(`[SheetOffsets] Failed to load sheet offsets in ${context}`, error);
    return undefined;
  }
}

export function loadSheetOffsetsOrEmpty(offsets: string, context: string): SheetOffsets {
  return tryLoadSheetOffsets(offsets, context) ?? SheetOffsetsWasm.empty();
}
